var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content invoiceDetails" },
    [
      _c("Breadcrumbs", { attrs: { breadcrumbs: _vm.breadcrumbs } }),
      _vm._v(" "),
      _vm.modalExportData
        ? _c(
            "EmptyCardModal",
            {
              ref: "exportXlsModal",
              attrs: {
                modalData: _vm.modalExportData,
                onModalClose: () => (_vm.modalExportData = null),
                onModalAccept: () => _vm.exportToFile(true),
              },
            },
            [
              _vm._t("default", function () {
                return [
                  _c(
                    "div",
                    [
                      _c("ExcelExportOptions", {
                        ref: "exportExcelOptions",
                        attrs: {
                          extraOptions: {
                            expDatesSelected: _vm.showExpiresDatesBefore,
                            priceQtyRate: true,
                            showDetailsExpireDates: true,
                            groupPrices: true,
                            validDates: true,
                            invoiceNum: true,
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modalData.open
        ? _c("sideBarInvoiceModalModal", {
            attrs: { modalData: _vm.modalData, onModalClose: _vm.closeModal },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _vm.typeTitle[_vm.type]
                ? _c("h5", [
                    _vm._v("Накладные типа: "),
                    _c("strong", [_vm._v(_vm._s(_vm.typeTitle[_vm.type]))]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex invoicesDrugSearchBlock" },
                [
                  _vm.type !== "grouped"
                    ? [
                        _c("div", [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-success mr-2",
                              on: { click: _vm.getInvoicesByFilter },
                            },
                            [_vm._v("Сгруппировать выбранные")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mr-2" }, [
                          _c("div", { staticClass: "col-md-4" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.invoiceType,
                                    expression: "invoiceType",
                                  },
                                ],
                                staticClass: "form-control mr-2",
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.invoiceType = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                    function ($event) {
                                      return _vm.getInvoices()
                                    },
                                  ],
                                },
                              },
                              [
                                _c("option", { attrs: { value: "all" } }, [
                                  _vm._v("Все накладные"),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.typeTitle, function (title, index) {
                                  return _c(
                                    "option",
                                    { domProps: { value: index } },
                                    [_vm._v(_vm._s(title))]
                                  )
                                }),
                              ],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.invoiceStatus,
                                    expression: "invoiceStatus",
                                  },
                                ],
                                staticClass: "form-control mr-2",
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.invoiceStatus = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                    function ($event) {
                                      return _vm.getInvoices()
                                    },
                                  ],
                                },
                              },
                              [
                                _c("option", { attrs: { value: "all" } }, [
                                  _vm._v("Все статусы"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "1" } }, [
                                  _vm._v("Готовится"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2" } }, [
                                  _vm._v("В дороге"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "3" } }, [
                                  _vm._v("Модерация"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "6" } }, [
                                  _vm._v("Проверка приемки"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "4" } }, [
                                  _vm._v("Сборка"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "5" } }, [
                                  _vm._v("Резерв"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "0" } }, [
                                  _vm._v("Закрыт"),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedCurrency,
                                    expression: "selectedCurrency",
                                  },
                                ],
                                staticClass: "form-control mr-2",
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.selectedCurrency = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c("option", { attrs: { value: "0" } }, [
                                  _vm._v("Любая валюта закупки"),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.$AllCurrencies, function (currency) {
                                  return _c(
                                    "option",
                                    { domProps: { value: currency.id } },
                                    [_vm._v(_vm._s(currency.currency))]
                                  )
                                }),
                              ],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-8" }, [
                            _c("div", { staticClass: "flex" }, [
                              _vm.show.storeOut
                                ? _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.storeSelected.out,
                                          expression: "storeSelected.out",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      on: {
                                        change: [
                                          function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              _vm.storeSelected,
                                              "out",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                          function ($event) {
                                            return _vm.getInvoices()
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c("option", { attrs: { value: "0" } }, [
                                        _vm._v("Все склады"),
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.getSortedStores(),
                                        function (store) {
                                          return _c(
                                            "option",
                                            { domProps: { value: store.id } },
                                            [_vm._v(_vm._s(store.title))]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.show.storeIn && _vm.show.storeOut
                                ? _c("span", { staticClass: "span_divider" }, [
                                    _vm._v(" >> "),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.show.storeIn
                                ? _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.storeSelected.in,
                                          expression: "storeSelected.in",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      on: {
                                        change: [
                                          function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              _vm.storeSelected,
                                              "in",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                          function ($event) {
                                            return _vm.getInvoices()
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c("option", { attrs: { value: "0" } }, [
                                        _vm._v("Все склады"),
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.getSortedStores(),
                                        function (store) {
                                          return _c(
                                            "option",
                                            { domProps: { value: store.id } },
                                            [_vm._v(_vm._s(store.title))]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-md-4" },
                            [
                              _c("DrugSearchNew", {
                                attrs: { onSelect: _vm.selectDrug },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.invoiceSubStatus,
                                    expression: "invoiceSubStatus",
                                  },
                                ],
                                staticClass: "form-control mr-2",
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.invoiceSubStatus = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                    function ($event) {
                                      return _vm.getInvoices()
                                    },
                                  ],
                                },
                              },
                              [
                                _c("option", { attrs: { value: "all" } }, [
                                  _vm._v("Все подсклады"),
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.getSortedSubStores(),
                                  function (s, index) {
                                    return [
                                      _c(
                                        "optgroup",
                                        { attrs: { label: s.storeTitle } },
                                        _vm._l(s.subStores, function (ss) {
                                          return _c(
                                            "option",
                                            { domProps: { value: ss.id } },
                                            [_vm._v(_vm._s(ss.title))]
                                          )
                                        }),
                                        0
                                      ),
                                    ]
                                  }
                                ),
                              ],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4 offset-4" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.invoiceNumber,
                                  expression: "invoiceNumber",
                                },
                              ],
                              staticClass: "form-control mr-2",
                              attrs: {
                                type: "text",
                                placeholder: "10555, 12000....",
                              },
                              domProps: { value: _vm.invoiceNumber },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.invoiceNumber = $event.target.value
                                },
                              },
                            }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          _vm._l(_vm.totalInvoiceStatuses, function (s) {
                            return _c(
                              "span",
                              {
                                class: {
                                  badge: true,
                                  "mr-2": true,
                                  "badge-success": +s.status === 0,
                                  "badge-info":
                                    +s.status === 1 || +s.status === 4,
                                  "badge-primary":
                                    +s.status === 2 || +s.status === 5,
                                  "badge-warning": +s.status === 3,
                                  pointer: true,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.searchByStatus(s.status)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.statusTitles[s.status]) + " "
                                ),
                                _c("strong", [
                                  _vm._v("(" + _vm._s(s.total) + ")"),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type === "grouped"
                    ? [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-success mr-2",
                            on: {
                              click: function ($event) {
                                return _vm.getInvoices()
                              },
                            },
                          },
                          [_vm._v("Показать накладные")]
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type === "income" || _vm.type === "grouped"
                    ? _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-info mr-2",
                            on: {
                              click: function ($event) {
                                return _vm.createTransit()
                              },
                            },
                          },
                          [_vm._v("Создать перемещение")]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {},
                    [
                      _c(
                        "vue-ladda",
                        {
                          attrs: {
                            "button-class": "btn btn-sm btn-info",
                            "data-style": "zoom-in",
                            loading: _vm.loadingBtn,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.getInvoices()
                            },
                          },
                        },
                        [_vm._v("Поиск\n              ")]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _vm.records && _vm.type === "grouped"
                ? _c("div", { staticClass: "pull-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-info",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            _vm.showExpiresDatesInInvoices =
                              !_vm.showExpiresDatesInInvoices
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.showExpiresDatesInInvoices
                              ? "Скрыть скроки годности в накладных"
                              : "Показать скроки годности в накладных"
                          ) + "\n            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-success",
                        on: { click: _vm.printTable },
                      },
                      [_vm._v("Печать")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-success",
                        on: {
                          click: function ($event) {
                            return _vm.exportToFile()
                          },
                        },
                      },
                      [_vm._v("Экспорт в XLS")]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.type !== "grouped" && _vm.selectedInvoices.length
                ? _c("div", [
                    _c("p", { staticClass: "mb-1" }, [
                      _vm._v("Выбранные накладные"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex" },
                      _vm._l(_vm.selectedInvoices, function (i) {
                        return _c(
                          "span",
                          { staticClass: "badge badge-pill badge-info mr-1" },
                          [
                            _c("i", {
                              staticClass:
                                "icon-fa icon-fa-remove pointer hover-red",
                              on: {
                                click: function ($event) {
                                  _vm.selectedInvoices =
                                    _vm.selectedInvoices.filter(
                                      (inv) => inv.id !== i.id
                                    )
                                },
                              },
                            }),
                            _vm._v(
                              "\n                " +
                                _vm._s(i.id) +
                                "\n              "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-info btn-xs",
                      on: {
                        click: function ($event) {
                          _vm.showFiles = !_vm.showFiles
                        },
                      },
                    },
                    [_vm._v("просмотреть файлы")]
                  ),
                  _vm._v(" "),
                  _vm.showFiles && _vm.invoices && _vm.invoices.length
                    ? [
                        _c("FilesByInvoices", {
                          attrs: { invoices: _vm.invoices.map((i) => i.id) },
                        }),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-1" },
                [
                  !_vm.suppliers || !_vm.suppliers.length
                    ? _c("LoadingButton", {
                        attrs: {
                          title: "Обновить цены поставщиков",
                          type: "button",
                          loading: _vm.btnLoadingSuppliers,
                          color: _vm.$constants.PRIMARY_COLOR,
                          onClick: () => _vm.getSuppliers(),
                          className: "btn btn-outline-success btn-xs",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.suppliers && _vm.suppliers.length
                    ? [
                        _c(
                          "div",
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Поставщики"),
                            ]),
                            _vm._v(" "),
                            _c("multiselect", {
                              attrs: {
                                options: _vm.suppliers,
                                "track-by": "title",
                                label: "displayTitle",
                                "show-labels": false,
                                placeholder: "Выберите поставщика",
                                multiple: true,
                              },
                              model: {
                                value: _vm.selectedSuppliers.suppliers,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.selectedSuppliers,
                                    "suppliers",
                                    $$v
                                  )
                                },
                                expression: "selectedSuppliers.suppliers",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "text-right mt-1" },
                          [
                            _c("LoadingButton", {
                              attrs: {
                                title:
                                  "Импортировать цены с инвойсов к поставщикам",
                                type: "button",
                                loading: _vm.btnLoadingSuppliers,
                                color: _vm.$constants.SUCCESS_COLOR,
                                onClick: () => _vm.updateSupplierPrices(),
                                className: "btn btn-outline-success btn-xs",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.records && _vm.type === "grouped"
          ? _c("div", { staticClass: "col-md-12" }, [
              _c("div", { staticClass: "card" }, [
                _c(
                  "div",
                  { staticClass: "card-body", attrs: { id: "printTable2" } },
                  [
                    _c("div", { staticClass: "flex justify-content-between" }, [
                      _c("div", [
                        _c("div", { staticClass: "input-group" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.minusInvoices,
                                expression: "minusInvoices",
                              },
                            ],
                            staticClass: "m-t-5",
                            attrs: { type: "checkbox", id: "ch_1" },
                            domProps: {
                              checked: Array.isArray(_vm.minusInvoices)
                                ? _vm._i(_vm.minusInvoices, null) > -1
                                : _vm.minusInvoices,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.minusInvoices,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.minusInvoices = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.minusInvoices = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.minusInvoices = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "pointer p-l-5 mb-0",
                              attrs: { for: "ch_1" },
                            },
                            [_vm._v("Вычитать текущие инвойсы")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-group" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.showFields.storeRemain,
                                expression: "showFields.storeRemain",
                              },
                            ],
                            staticClass: "m-t-5",
                            attrs: { type: "checkbox", id: "ch_2" },
                            domProps: {
                              checked: Array.isArray(_vm.showFields.storeRemain)
                                ? _vm._i(_vm.showFields.storeRemain, null) > -1
                                : _vm.showFields.storeRemain,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.showFields.storeRemain,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.showFields,
                                        "storeRemain",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.showFields,
                                        "storeRemain",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.showFields, "storeRemain", $$c)
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "pointer p-l-5 mb-0",
                              attrs: { for: "ch_2" },
                            },
                            [_vm._v("Показать остатки на складах")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-group p-b-10" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.showFields.country,
                                expression: "showFields.country",
                              },
                            ],
                            staticClass: "m-t-5",
                            attrs: { type: "checkbox", id: "ch_3" },
                            domProps: {
                              checked: Array.isArray(_vm.showFields.country)
                                ? _vm._i(_vm.showFields.country, null) > -1
                                : _vm.showFields.country,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.showFields.country,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.showFields,
                                        "country",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.showFields,
                                        "country",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.showFields, "country", $$c)
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "pointer p-l-5 mb-0",
                              attrs: { for: "ch_3" },
                            },
                            [_vm._v("Показать страну закупки")]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-right mb-2 flex flex_gap_10" },
                        [
                          _c("div", [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.showExpiresDatesBefore,
                                    expression: "showExpiresDatesBefore",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.showExpiresDatesBefore
                                  )
                                    ? _vm._i(_vm.showExpiresDatesBefore, null) >
                                      -1
                                    : _vm.showExpiresDatesBefore,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.showExpiresDatesBefore,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.showExpiresDatesBefore =
                                            $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.showExpiresDatesBefore = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.showExpiresDatesBefore = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(
                                "\n                  Показать сроки годности до:"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.expDate,
                                  expression: "expDate",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text", placeholder: "mm.YYYY" },
                              domProps: { value: _vm.expDate },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.expDate = $event.target.value
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c("p", [
                                _vm._v("Сгруппированы инвойсы "),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.selectedInvoices
                                        .map((i) => i.id)
                                        .join(", ")
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "mb-1" }, [
                                _vm._v("Всего упаковок: "),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.records.reduce(
                                        (acc, r) => acc + r.qty,
                                        0
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              Object.values(_vm.selectedLine).find((v) => v)
                                ? [
                                    _c("p", { staticClass: "mb-1" }, [
                                      _vm._v("Выделено:\n                    "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.records.reduce(
                                              (acc, r, i) =>
                                                acc +
                                                (_vm.selectedLine[i]
                                                  ? r.qty
                                                  : 0),
                                              0
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "table",
                      {
                        staticClass:
                          "table table-hover table-sm invoices_table",
                      },
                      [
                        _c("thead", [
                          _c("tr", [
                            _c("th"),
                            _vm._v(" "),
                            _c("th"),
                            _vm._v(" "),
                            _c("th", [_vm._v("Инвойсы")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Препарат")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Количество")]),
                            _vm._v(" "),
                            _vm.showFields.storeRemain
                              ? _c("th", [_vm._v("На ЦС")])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showFields.country
                              ? _c("th", [_vm._v("Страна закупки")])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showExpiresDatesBefore
                              ? _c("th", [_vm._v("Сроки годности")])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showExpiresDatesInInvoices
                              ? _c("th", [_vm._v("Сроки годности в накладных")])
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(
                            _vm.getFilteredRecords(_vm.records),
                            function (record, index) {
                              return _c(
                                "tr",
                                { class: { mark: _vm.selectedLine[index] } },
                                [
                                  _c("td", [_vm._v(_vm._s(index + 1))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("input", {
                                      attrs: { type: "checkbox" },
                                      on: {
                                        change: function ($event) {
                                          return _vm.selectLine($event, index)
                                        },
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    _vm._l(record.invoices, function (inv) {
                                      return _c(
                                        "div",
                                        { staticClass: "flex mb-2" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "mr-2 font-weight-bold align-self-center",
                                            },
                                            [_vm._v(_vm._s(inv))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-xs btn-success newWindowBtn mr-2",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openInNewPage(
                                                    "InvoicesEdit",
                                                    { id: inv }
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "icon-fa icon-fa-external-link",
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-xs btn-info newWindowBtn",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openInvoiceInModal(
                                                    inv
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "icon-fa icon-fa-eye",
                                              }),
                                            ]
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(record.drug.title) +
                                        " (" +
                                        _vm._s(record.drug.id) +
                                        ")\n                "
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "drug_info_block" },
                                      [
                                        record.drug &&
                                        record.drug.pack_set &&
                                        +record.drug.pack_set !== 1
                                          ? _c("p", [
                                              _vm._v(
                                                "Препарат комплектный:\n                    "
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "badge badge-info",
                                                },
                                                [_vm._v("1 комплект")]
                                              ),
                                              _vm._v(
                                                " -\n                    "
                                              ),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(record.drug.pack_set)
                                                ),
                                              ]),
                                              _vm._v(
                                                "\n                    (зав.уп.)"
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        record.drug && record.drug.cool
                                          ? _c("p", [
                                              _c("span", {
                                                staticClass:
                                                  "icon icon-snowflake",
                                              }),
                                              _vm._v(
                                                " необходим\n                    хладоген"
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        record.drug && record.drug.pack_comment
                                          ? _c(
                                              "p",
                                              { staticClass: "pack_comment" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    record.drug.pack_comment
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        record.drug &&
                                        record.drug.pack_box_comment
                                          ? _c(
                                              "p",
                                              {
                                                staticClass: "pack_box_comment",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      record.drug
                                                        .pack_box_comment
                                                    )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      record.drug &&
                                      record.drug.pack_set &&
                                      +record.drug.pack_set !== 1
                                        ? [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  Math.round(
                                                    (record.qty /
                                                      record.drug.pack_set) *
                                                      10
                                                  ) / 10
                                                )
                                              ),
                                            ]),
                                            _vm._v(" компл. "),
                                            _c("p", { staticClass: "mb-0" }, [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(record.qty) +
                                                  " зав.уп.)"
                                              ),
                                            ]),
                                          ]
                                        : [_vm._v(_vm._s(record.qty))],
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _vm.showFields.storeRemain
                                    ? _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.inStores &&
                                              _vm.inStores[record.drug.id]
                                              ? Math.round(
                                                  _vm.inStores[record.drug.id] -
                                                    (_vm.minusDrugs[
                                                      record.drug.id
                                                    ] || 0) -
                                                    (_vm.minusInvoices
                                                      ? record.qty
                                                      : 0)
                                                )
                                              : 0
                                          ) + "\n              "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showFields.country
                                    ? _c("td", [
                                        _vm._v(
                                          _vm._s(record.drug.country_name)
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showExpiresDatesBefore
                                    ? _c(
                                        "td",
                                        _vm._l(
                                          _vm.sortArray(
                                            record.drug?.valid_dates ?? [],
                                            "expire_date"
                                          ),
                                          function (d) {
                                            return d.is_active
                                              ? _c("p", [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.moment(
                                                          d.expire_date,
                                                          "DD.MM.YYYY"
                                                        )
                                                      )
                                                  ),
                                                ])
                                              : _vm._e()
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showExpiresDatesInInvoices
                                    ? _c(
                                        "td",
                                        [
                                          _c("ExpireDatesByMask", {
                                            attrs: {
                                              allToSelectDate: true,
                                              disableEdit: true,
                                              invoices: record.invoices,
                                              updateDates: (d) => {},
                                              drugId: record.drug.id,
                                              savedDates:
                                                _vm.savedExpireDates[
                                                  record.drug.id
                                                ],
                                              expireDates:
                                                _vm.drugExpireDates[
                                                  record.drug.id
                                                ],
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.invoices
          ? _c("div", { staticClass: "col-md-12" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c(
                    "table",
                    { staticClass: "table table-hover invoices_table" },
                    [
                      _c("thead", [
                        _c("tr", [
                          _c("th", { attrs: { width: "40" } }, [_vm._v("#")]),
                          _vm._v(" "),
                          _vm._m(0),
                          _vm._v(" "),
                          _c("th", [_vm._v("ID")]),
                          _vm._v(" "),
                          _vm.invoiceType === "all"
                            ? _c("th", [_vm._v("Тип накладной")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.invoiceType === "transit"
                            ? _c("th", [_vm._v("Направление")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.invoiceType === "writeOff"
                            ? _c("th", [_vm._v("Склад")])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("th", [_vm._v("Доставка")]),
                          _vm._v(" "),
                          _vm.invoiceType === "income"
                            ? _c("th", [_vm._v("Скидка")])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("th", [_vm._v("Комментарий")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Создание")]),
                          _vm._v(" "),
                          _c("th"),
                          _vm._v(" "),
                          _c("th"),
                          _vm._v(" "),
                          _c("th", [_vm._v("Статус")]),
                          _vm._v(" "),
                          _c("th"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.invoices, function (invoice, index) {
                          return _c(
                            "tr",
                            {
                              key: index,
                              class: `tr_class_${
                                _vm.trClasses[invoice.status]
                              }`,
                            },
                            [
                              _c("td", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectedInvoices,
                                      expression: "selectedInvoices",
                                    },
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    value: invoice,
                                    checked: Array.isArray(_vm.selectedInvoices)
                                      ? _vm._i(_vm.selectedInvoices, invoice) >
                                        -1
                                      : _vm.selectedInvoices,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.selectedInvoices,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = invoice,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.selectedInvoices = $$a.concat([
                                              $$v,
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.selectedInvoices = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.selectedInvoices = $$c
                                      }
                                    },
                                  },
                                }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(index + 1) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "text-center" },
                                [
                                  invoice.status === 1
                                    ? [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.selectedInvoicesForDelete,
                                              expression:
                                                "selectedInvoicesForDelete",
                                            },
                                          ],
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            value: invoice,
                                            checked: Array.isArray(
                                              _vm.selectedInvoicesForDelete
                                            )
                                              ? _vm._i(
                                                  _vm.selectedInvoicesForDelete,
                                                  invoice
                                                ) > -1
                                              : _vm.selectedInvoicesForDelete,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a =
                                                  _vm.selectedInvoicesForDelete,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = invoice,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.selectedInvoicesForDelete =
                                                      $$a.concat([$$v]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.selectedInvoicesForDelete =
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                }
                                              } else {
                                                _vm.selectedInvoicesForDelete =
                                                  $$c
                                              }
                                            },
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _c("div", { staticClass: "flex flex_gap_10" }, [
                                  invoice.hasConfirmedDrugs
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "v-popover",
                                            {
                                              attrs: {
                                                "auto-hide": true,
                                                placement: "right",
                                                delay: { show: 0, hide: 100 },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "badge badge-success pointer",
                                                },
                                                [
                                                  _c("v-icon", {
                                                    attrs: { name: "list" },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "template",
                                                { slot: "popover" },
                                                [
                                                  _c("p", [
                                                    _vm._v("Товар сверен"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.printDate(
                                                          invoice
                                                            .hasConfirmedDrugs
                                                            .updated_at,
                                                          "DD.MM.YYYY"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  invoice.hasConfirmedDrugs
                                                    ?.data?.user
                                                    ? _c("p", [
                                                        _vm._v(
                                                          _vm._s(
                                                            invoice
                                                              .hasConfirmedDrugs
                                                              .data.user
                                                          )
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  invoice.hasConfirmedExpDates
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "v-popover",
                                            {
                                              attrs: {
                                                "auto-hide": true,
                                                placement: "right",
                                                delay: { show: 0, hide: 100 },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "badge badge-success pointer",
                                                },
                                                [
                                                  _c("v-icon", {
                                                    attrs: {
                                                      name: "calendar-check",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "template",
                                                { slot: "popover" },
                                                [
                                                  _c("p", [
                                                    _vm._v("Сроки внесены"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.printDate(
                                                          invoice
                                                            .hasConfirmedExpDates
                                                            .updated_at,
                                                          "DD.MM.YYYY"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "align-self-center" },
                                    [
                                      invoice.details.find(
                                        (d) => d?.drug?.is_press_can
                                      )
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "badge badge-danger",
                                            },
                                            [
                                              _c("v-icon", {
                                                attrs: { name: "spray-can" },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("strong", [_vm._v(_vm._s(invoice.id))]),
                                    _vm._v(" "),
                                    invoice.use_for_autolist
                                      ? _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value:
                                                  "Накладная учитывается как резервная",
                                                expression:
                                                  "'Накладная учитывается как резервная'",
                                              },
                                            ],
                                            staticClass:
                                              "pointer badge badge-info",
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "icon-fa icon-fa-calendar-check-o",
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    invoice?.files?.length
                                      ? _c(
                                          "span",
                                          { staticClass: "badge badge-dark" },
                                          [_vm._v("файлы")]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm.invoiceType === "transit"
                                ? _c("td", [
                                    _c(
                                      "span",
                                      { staticClass: "badge badge-info" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$AllStores[invoice.store_out] &&
                                              _vm.$AllStores[invoice.store_out]
                                                .short_title
                                          ) +
                                            " ==> " +
                                            _vm._s(
                                              _vm.$AllStores[
                                                invoice.store_in
                                              ] &&
                                                _vm.$AllStores[invoice.store_in]
                                                  .short_title
                                            )
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.invoiceType === "writeOff"
                                ? _c("td", [
                                    _c(
                                      "span",
                                      { staticClass: "badge badge-info" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$AllStores[invoice.store_out] &&
                                              _vm.$AllStores[invoice.store_out]
                                                .short_title
                                          )
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.invoiceType === "all"
                                ? _c(
                                    "td",
                                    [
                                      _c("p", {
                                        staticClass: "mb-1",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.printLabel(invoice.type, "type")
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      invoice.type === 2
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "badge badge-info",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$AllStores[
                                                      invoice.store_out
                                                    ] &&
                                                      _vm.$AllStores[
                                                        invoice.store_out
                                                      ].short_title
                                                  ) +
                                                    " ==> " +
                                                    _vm._s(
                                                      _vm.$AllStores[
                                                        invoice.store_in
                                                      ] &&
                                                        _vm.$AllStores[
                                                          invoice.store_in
                                                        ].short_title
                                                    )
                                                ),
                                              ]
                                            ),
                                          ]
                                        : [
                                            invoice.type === 1
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "badge badge-info",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.$AllStores[
                                                            invoice.store_in
                                                          ] &&
                                                            _vm.$AllStores[
                                                              invoice.store_in
                                                            ].short_title
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                )
                                              : invoice.store_out
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "badge badge-info",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.$AllStores[
                                                            invoice.store_out
                                                          ] &&
                                                            _vm.$AllStores[
                                                              invoice.store_out
                                                            ].short_title
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(invoice.delivery_date))]),
                              _vm._v(" "),
                              _vm.invoiceType === "income"
                                ? _c("td", [
                                    invoice.discount
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(invoice.discount) +
                                              " " +
                                              _vm._s(
                                                invoice.discount_type == 1
                                                  ? "%"
                                                  : _vm.currencies[
                                                      invoice.currency_id
                                                    ]
                                              )
                                          ),
                                        ])
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(invoice.comment))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.moment(
                                      invoice.created_at,
                                      "DD.MM.YYYY HH:mm"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v("\n                Препаратов:"),
                                _c("strong", [
                                  _vm._v(_vm._s(invoice.details.length)),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _c("strong", [
                                    _vm._v(
                                      "(" +
                                        _vm._s(_vm.getSumOfDetails(invoice)) +
                                        " " +
                                        _vm._s(
                                          _vm.currencies[invoice.currency_id] ??
                                            _vm.currencies[28]
                                        )
                                    ),
                                    +invoice?.extra_settings
                                      ?.expenses_by_price ||
                                    +invoice?.extra_settings?.expenses_by_qty
                                      ? _c("span", [
                                          _vm._v(
                                            " /\n                  " +
                                              _vm._s(
                                                Math.round(
                                                  (_vm.getSumOfDetails(
                                                    invoice
                                                  ) +
                                                    +(
                                                      invoice?.extra_settings
                                                        ?.expenses_by_price ?? 0
                                                    ) +
                                                    +(
                                                      invoice?.extra_settings
                                                        ?.expenses_by_qty ?? 0
                                                    )) *
                                                    100
                                                ) / 100
                                              ) +
                                              " " +
                                              _vm._s(
                                                _vm.currencies[
                                                  invoice.currency_id
                                                ] ?? _vm.currencies[28]
                                              )
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                  _vm._v(")"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("p", [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.printLabel(invoice.status, "status")
                                      ),
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                invoice.sub_status &&
                                _vm.$invoiceSubStatuses[invoice.sub_status]
                                  ? _c("p", [
                                      _c(
                                        "span",
                                        { staticClass: "badge badge-dark" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$invoiceSubStatuses[
                                                invoice.sub_status
                                              ].title
                                            )
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  [1, 2].includes(invoice.status)
                                    ? [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm
                                                  .selectedInvoicesForStatusChange[
                                                  invoice.id
                                                ],
                                              expression:
                                                "selectedInvoicesForStatusChange[invoice.id]",
                                            },
                                          ],
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            value: invoice,
                                            checked: Array.isArray(
                                              _vm
                                                .selectedInvoicesForStatusChange[
                                                invoice.id
                                              ]
                                            )
                                              ? _vm._i(
                                                  _vm
                                                    .selectedInvoicesForStatusChange[
                                                    invoice.id
                                                  ],
                                                  invoice
                                                ) > -1
                                              : _vm
                                                  .selectedInvoicesForStatusChange[
                                                  invoice.id
                                                ],
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a =
                                                  _vm
                                                    .selectedInvoicesForStatusChange[
                                                    invoice.id
                                                  ],
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = invoice,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.selectedInvoicesForStatusChange,
                                                      invoice.id,
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.selectedInvoicesForStatusChange,
                                                      invoice.id,
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.selectedInvoicesForStatusChange,
                                                  invoice.id,
                                                  $$c
                                                )
                                              }
                                            },
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-xs btn-success",
                                    on: {
                                      click: function ($event) {
                                        return _vm.mixinGoToRouter(
                                          "InvoicesEdit",
                                          { id: invoice.id }
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Показать\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-xs btn-success newWindowBtn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.openInNewPage(
                                          "InvoicesEdit",
                                          { id: invoice.id }
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "icon-fa icon-fa-external-link",
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-xs btn-info newWindowBtn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.openInvoiceInModal(
                                          invoice.id
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-fa icon-fa-eye",
                                    }),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-2 flex justify-content-between" },
                    [
                      _c("deleteButton", {
                        attrs: {
                          selected: _vm.selectedInvoicesForDelete,
                          updateRecordsBySelected: _vm.updateRecordsBySelected,
                        },
                      }),
                      _vm._v(" "),
                      _c("div", [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Групповое изменение статуса"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex" },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.groupStatusSelected,
                                      expression: "groupStatusSelected",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.groupStatusSelected = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "1" } }, [
                                    _vm._v("Предварительная накладная"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "2" } }, [
                                    _vm._v("Накладная в дороге"),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticStyle: { "min-width": "150px" } },
                                [
                                  _c("datetime", {
                                    attrs: {
                                      "input-class": "form-control",
                                      type: "datetime",
                                      "minute-step": 60,
                                      format: "dd.MM.yyyy HH:mm",
                                      auto: true,
                                      "value-zone": "local",
                                      zone: "local",
                                      "min-datetime": _vm.dateStatusLimits.min,
                                      "max-datetime": _vm.dateStatusLimits.max,
                                    },
                                    model: {
                                      value: _vm.dateStatusChange,
                                      callback: function ($$v) {
                                        _vm.dateStatusChange = $$v
                                      },
                                      expression: "dateStatusChange",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "vue-ladda",
                                {
                                  attrs: {
                                    "button-class":
                                      "btn btn-sm btn-outline-info",
                                    "data-style": "zoom-in",
                                    loading: _vm.groupUpdateLoading,
                                  },
                                  on: {
                                    click: () => _vm.updateGroupedInvoices(),
                                  },
                                },
                                [_vm._v("Сохранить\n                  ")]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Групповое изменение сабсклада"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "input-group" },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.groupSubStatusSelected,
                                      expression: "groupSubStatusSelected",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.groupSubStatusSelected = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "0" } }, [
                                    _vm._v("Сбросить сабсклад"),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.$invoiceSubStatuses, function (s) {
                                    return _c(
                                      "option",
                                      { domProps: { value: s.id } },
                                      [_vm._v(_vm._s(s.title))]
                                    )
                                  }),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("LoadingButton", {
                                attrs: {
                                  title: "обновить",
                                  loading: _vm.groupUpdateLoading,
                                  type: "button",
                                  color: _vm.$constants.PRIMARY_COLOR,
                                  onClick: () =>
                                    _vm.updateGroupedInvoices("subStatus"),
                                  className: "btn btn-sm btn-outline-info",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.paginator
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _vm._v("\n      Всего инвойсов: "),
              _c("strong", [_vm._v(_vm._s(_vm.paginator.total))]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pull-right" },
                [
                  _c("paginate", {
                    attrs: {
                      "page-count": _vm.paginator.last_page,
                      "page-range": 3,
                      "margin-pages": 2,
                      "click-handler": _vm.getInvoices,
                      "prev-text": "&laquo",
                      "next-text": "&raquo",
                      "container-class": "pagination",
                      "prev-class": "page-item",
                      "prev-link-class": "page-link",
                      "page-class": "page-item",
                      "page-link-class": "page-link",
                      "next-class": "page-item",
                      "next-link-class": "page-link",
                      "active-class": "active green_btn",
                    },
                    model: {
                      value: _vm.currentPage,
                      callback: function ($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage",
                    },
                  }),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("th", { staticClass: "text-center", attrs: { width: "40" } }, [
      _c("i", { staticClass: "icon-fa icon-fa-trash" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }